import React, { useEffect, useState } from "react";
import "./lucyVoice.css";
import { useStores } from "../../store/index";
// import { Observer } from "mobx-react";
import { observer } from "mobx-react";

const LucyVoice = observer(() => {
  const { InterviewStore } = useStores();
  const div1 = document.querySelector(".div1");
  const div2 = document.querySelector(".div2");
  const div3 = document.querySelector(".div3");
  const div4 = document.querySelector(".div4");
  const div5 = document.querySelector(".div5");

  const [height, setHeight] = useState("0");

  let tempBotCC = "";

  // useEffect(() => {
  // console.log("bot cc>>>>>>>>>>>>",InterviewStore.botCC)
  // }, [InterviewStore.botCC])

  useEffect(() => {
    let index = 0;

    // console.log( "bot cc>>>>>>", InterviewStore.botCC );
    const sentence = InterviewStore.botCC;
    tempBotCC = sentence;
    const array = sentence.split(" ");
    // console.log("this is an array of sentence", array);
    const wordLengths = array.map((word) => word.length * 10);
    // const wordLengths = [30, 50, 100, 120, 130, 100, 80, 50, 20]
    console.log(wordLengths);

    //     wordLengths.forEach((length, index) => {
    // setTimeout(() => {
    //   setHeight(`${length}`); // Adjust the height scaling as needed
    // },  300); // Delay each height update by 1 second
    const interval = setInterval(() => {
      if (index < wordLengths.length) {
        setHeight(wordLengths[index]);
        index++;
      } else {
        setHeight("0");
        clearInterval(interval);
      }
    }, 430);
  }, [InterviewStore.botCC]);

  // useEffect( () =>
  // {
  //   if ( speaking == (true) )
  //   {
  //     setInterval( () =>
  //     {
  //       if ( height === "0" ) setHeight( "50" );
  //       else setHeight( "0" );
  //     }, 1000 );
  //   }
  //   return () => {
  //     setHeight( "0" );
  //     // Cleanup the interval on unmount or when speaking becomes false
  //   };
  // }, [speaking]);

  const style = {
    // backgroundColor: 'rgb(59 130 246)',
    padding: "2px",
    height: `${height}px`,
    margin: "2px",
    borderBottomLeftRadius: "10px",
    borderBottomRightRadius: "10px",
  };

  const style2 = {
    // backgroundColor: 'rgb(59 130 246)',
    padding: "2px",
    height: `${height / 4}px`,
    margin: "2px",
    borderBottomLeftRadius: "10px",
    borderBottomRightRadius: "10px",
  };
  const style1 = {
    // backgroundColor: 'rgb(59 130 246)',
    padding: "2px",
    height: `${height / 2}px`,
    margin: "2px",
    borderBottomLeftRadius: "10px",
    borderBottomRightRadius: "10px",
  };
  return (
    <div className="ld">
      <div style={style2} class="div1 reflections bg-primary"></div>
      <div style={style1} class="div2 reflections bg-primary"></div>
      <div style={style} class="div3 reflections bg-primary"></div>
      <div style={style1} class="div4 reflections bg-primary"></div>
      <div style={style2} class="div5 reflections bg-primary"></div>
    </div>
  );
});

export default LucyVoice;
